import React, { Component, Fragment } from 'react';
import Dialog from '@material-ui/core/Dialog';
import VMButton from '@/Common/VMButton';
import './GIFCropDialog.scss'
import i18n from '@/i18n';
import InputRangeSlider from './VideoSlider/VideoSlider';
import "./VideoSlider/VideoSlider.scss"
import './CropDialog.scss';

const UNIT = 1000;
class GIFCropDialog extends Component {
    state = {

        isReadyVideo: false,
        isPause: false,
        cropDuration:8,
        curVideoTime: 0, // (s)
        duration: null, // 영상 길이
        startPoint: 0,
        remainder:0

    };
    
    videoRef;
    src;
    intervalId;
    orgScale;

    // canvas;
    videoImg;

    value = { min:0, max:8000 }


    componentDidMount = () => {
        if (this.props.src) {
            this.setState({ src: this.props.src });
        }
    }
    
    componentDidUpdate = (prevProps) => {
        const { selectedVideo } = this.props;
        const { gif = {} } = prevProps.selectedVideo
        if (selectedVideo.gif &&
            (gif.state !== selectedVideo.gif.state) &&
            selectedVideo.gif.state === "Finish" && selectedVideo.gif.url) {
            this.props.onGIFDownload(this.props.selectedVideo.gif.url, this.props.selectedVideo.name)
        }
    }

    getFloorValue = (value) => Math.floor(value / UNIT) * UNIT;

    checkFrameInRange = () => {
        const desDuration = this.value.max;
        try {
            const curVideoTime = this.videoRef.currentTime

            // 크롭영역 재생시간이 초과한 경우 
            if(curVideoTime >= desDuration)
            {
                // 다시 재생 (처음부터 루프)
                this.playAll()
            }
        } catch (e) {
            clearInterval(this.intervalId);
        }
    }

    changeTime = (time) => {
        let { min, max } = time;
        max = (max + this.state.remainder) / UNIT;
        min /= UNIT;
        this.value = { min, max };
        if (this.videoRef) {
            this.setState({ isPause: false });
            this.videoRef.currentTime = min;

            this.setState({ cropDuration: max  - min, startPoint: min })
            this.videoRef.play()
        }
    }

    playAll = (isPause = false, restart = true) => {
        const { isReadyVideo } = this.state
        if(isReadyVideo) {
            if(restart) {
                this.videoRef.currentTime = this.value.min
            }
            if(isPause) {
                this.videoRef.pause()
            }
            else {
                this.videoRef.play()
            }
        }
    }

    renderGIFStatus = () => {
        const { gif = {} } = this.props.selectedVideo
        if (!gif.state || gif.state === "Finish") return

        if (gif.state === "Error") return (
            <div className='gif-rendering-alert-area'>
                <div className='gif-rendering-alert'>
                    <img className="fail-img" src="https://front.videomonster.com/images-7cuytg20/web/myvideo/failRender.png" alt="" />
                    <div className="gif-alert-text">{i18n.t("myvideo.gif.error.text")}</div>
                </div>
            </div>
        )
        if (gif.state === "Rendering" || gif.state === "Waiting") return (
            <div className='gif-rendering-alert-area'>
                <div className='gif-rendering-alert'>
                    <img className="circle-img" src="https://front.videomonster.com/images-7cuytg20/web/v2/projectState/rendering.svg" alt="edit_icon" />
                    <div className="gif-alert-text">{i18n.t("myvideo.gif.create.text")}</div>
                </div>
            </div>
        )
    }

    renderCropper = () => {
        const { duration } = this.state
        const { selectedVideo } = this.props
        const isGifRenderFinish = selectedVideo && (!selectedVideo.gif || selectedVideo.gif.state === "Finish" || selectedVideo.gif.state === "Error" || (selectedVideo.gif.url && !selectedVideo.gif.state))
        return (
            <Fragment>
                <div className='video-wrapper'>
                    <video
                        ref={ref => { this.videoRef = ref; }}
                        src={this.state.src}
                        id='v'
                        width={600}
                        height={375.5}
                        muted
                        autoPlay
                        onLoadedData={(e) => {
                            if (!duration) {
                                const convertSeconds = e.target.duration * UNIT;
                                const duration = this.getFloorValue(convertSeconds);
                                const remainder = convertSeconds - duration;
                                const cropDuration = (Math.min(duration, 8000) + remainder) / UNIT;

                                this.value = { min: 0, max: cropDuration };
                                this.setState({
                                    isReadyVideo: true,
                                    duration,
                                    remainder,
                                    cropDuration
                                });
                            }
                        }}
                        onPlaying={() => {
                            clearInterval(this.intervalId);
                            this.intervalId = setInterval(this.checkFrameInRange, 33);
                        }}
                        onError={() => {
                            this.props.onClose();
                            alert(i18n.t("makevideo.error.unsupported.video"))
                        }}
                    />
                    { this.renderGIFStatus() }
                    
                </div>
                <br></br>
                <p className="dialog_subtitle" style={{ marginTop: '15px' }}>
                    {i18n.t("videocrop-subtitle2")}
                    <img src="https://front.videomonster.com/images-7cuytg20/web/ic_crop_duration.png" alt="" />
                </p>
                <p className="videoCrop-container-text">{i18n.t("gifcreate-text")}</p>

                <div className="video-slider-container">
                    {duration && <InputRangeSlider max={duration} onChangeTime={this.changeTime} disabled={!isGifRenderFinish} />}
                </div>
            </Fragment>
        );

    }
    render() {
        const { open, onClose, videoId, onComplete, onGIFDownload, selectedVideo } = this.props;
        const { name, gif, state } = selectedVideo
        const { startPoint, cropDuration } = this.state;
        const style = {
            float: 'left',
            fontSize: '14px',
            fontFamily: 'Pretendard'
        }
        if(!selectedVideo) return
        return (
            <Dialog open={open} maxWidth={"lg"} onClose={onClose}>
                <div className="gifCrop-container">
                <img className='close' src='https://front.videomonster.com/images-7cuytg20/web/cafe24/close.svg' alt='close' onClick={onClose}/>
                    <div 
                        style={{ height: "100%" }}
                        ref={ref => ref && ref.focus()}
                        tabIndex="0"
                    >
                        <p className="dialog_title">{i18n.t("gifcreate-title")}</p>
                        {this.renderCropper()}
                        <div className="VMButton-container">
                            {
                                gif && gif.url && gif.state === 'Finish'
                                    ?
                                    <VMButton color='white' onClick={() => onGIFDownload(gif.url, name)} width={'98px'} height={'34px'} style={{ float: 'left', fontSize: '14px', fontFamily: 'Pretendard' }} >{i18n.t("VideoDialog.ButtonText.download")}</VMButton>
                                    :
                                    <VMButton color="disabled3" width={'98px'} height={'34px'} style={{ float: 'left', pointerEvents: 'none', fontSize: '14px', fontFamily: 'Pretendard' }} >{i18n.t("VideoDialog.ButtonText.download")}</VMButton>
                            }
                            {
                                !gif || gif.state === 'Finish' || gif.state === "Error"
                                    ?
                                    <VMButton color="black-hover" onClick={() => onComplete(videoId, startPoint, cropDuration)} style={style} width={'100px'} height={'36px'}>{i18n.t("VideoDialog.menu.create.gif")}</VMButton>
                                    :
                                    <VMButton color="disabled2" style={{ height: '100%', pointerEvents: 'none', fontSize: '14px', fontFamily: 'Pretendard' }} width={'100px'} height={'36px'}>{i18n.t("VideoDialog.menu.create.gif")}</VMButton>
                            }
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default GIFCropDialog;